<!--
 * @Author: your name
 * @Date: 2020-08-18 11:28:28
 * @LastEditTime: 2020-09-16 23:19:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /backyard-ms/src/views/payroll/wage/modal/add-project.vue
-->
<template>
  <el-dialog
    append-to-body
    :title="$t('36')"
    :visible.sync="visible"
    v-if="visible"
    @close="closeHandle"
    :close-on-click-modal="false"
    width="800px"
  >
    <section>
      <p>1: {{ $t('47') }}</p>
      <span class="upload-dialog-des">{{ $t('46') }}</span>
      <el-row>
        <el-col :span="8">
          <el-button class="el-icon-download" @click="handleExport('month')">{{ $t('929') }}</el-button>
        </el-col>
        <el-col :span="8">
          <el-button class="el-icon-download" @click="handleExport('day')">{{ $t('930') }}</el-button>
        </el-col>
        <el-col :span="8">
          <el-button class="el-icon-download" @click="handleExport('other')">{{ $t('931') }}</el-button>
        </el-col>
      </el-row>
    </section>
    <section>
      <p>2: {{ $t('39') }}</p>
      <el-upload
        class="upload-demo"
        drag
        ref="upload"
        :action="uploadUrl"
        :file-format="fileFormat"
        :multiple="multiple"
        :headers="baseHeaders"
        :before-upload="beforeUploadHandle"
        :on-success="successHandle"
        :on-error="errorHandle"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          <em>{{ $t('728') }}</em>
        </div>
        <div class="el-upload__tip" slot="tip">{{ $t('40') }}</div>
      </el-upload>
    </section>
    <section style="text-align: center; color: #409eff">
      <p v-if="uploadStatus">
        {{ $t('978') }}:
        {{
          $t('654', {
            x: uploadTotalCount,
            y: uploadSuccessCount,
            z: uploadFailCount
          })
        }}
      </p>
      <p
        v-if="feedbackFileUrl"
        style="text-decoration: underline; margin-top: 10px; cursor: pointer"
        @click="handleOpenUrl"
      >
        {{ $t('934') }}
      </p>
    </section>
    <!-- 确认取消 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" @click="doSubmit">{{ $t('67') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { payrollStaffTpl } from '@/api/payroll'
import { baseHeaders } from 'util/axios-request'
const baseURL = process.env.VUE_APP_BASE_API
export default {
  data() {
    return {
      visible: false,
      multiple: true,
      fileFormat: ['.xls', '.xlsx'],
      uploadUrl: baseURL + 'web/payroll_staff/uploadStaffPayInfoData',
      baseHeaders: baseHeaders(),
      fileSize: 5,
      uploadHeaders: {},
      successFileList: [],
      uploadStatus: false,
      uploadTotalCount: 0, // 总数
      uploadSuccessCount: 0, // 成功数
      uploadFailCount: 0, // 失败数
      feedbackFileUrl: '',
      form: {
        name: ''
      }
    }
  },
  methods: {
    init() {
      this.visible = true
    },
    async handleExport(type) {
      const res = await payrollStaffTpl({ settlement_type: type })
      if (res && res.code === 1) window.open(res.data.template_url)
    },
    beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        const fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(
            this.$t('729', {
              fileFormat: this.fileFormat.join()
            })
          )
          return false
        }
      } else {
        // this.listType = "text";
      }

      // 文件大小
      if (!(file.size / 1024 / 1024 < this.fileSize)) {
        this.$message.error(
          this.$t('730', {
            fileSize: this.fileSize
          })
        )
        return false
      }
    },
    // 上传成功+
    successHandle(res, file) {
      if (this.$refs.upload.uploadFiles.length > 1) {
        this.$refs.upload.uploadFiles.splice(0, 1)
      }
      this.uploadTotalCount = 0 // 总数
      this.uploadSuccessCount = 0 // 成功数
      this.uploadFailCount = 0 // 失败数
      const response = res
      const data = response.data
      if (response && response.code === 1) {
        this.uploadStatus = true
        if (data.upload_result_state === 1) {
          // 全部成功
          this.uploadTotalCount = data.upload_total_count
          this.uploadSuccessCount = data.upload_success_count
          this.uploadFailCount = data.upload_fail_count
          this.$message.success(this.$t('935'))
          this.feedbackFileUrl = ''
        } else if (data.upload_result_state === 5) {
          // 部分成功
          this.uploadTotalCount = data.upload_total_count
          this.uploadSuccessCount = data.upload_success_count
          this.uploadFailCount = data.upload_fail_count
          this.feedbackFileUrl = data.feedback_file_url
          this.$message.error(this.$t('936'))
        } else if (data.upload_result_state === 3) {
          // 全部失败
          this.uploadTotalCount = data.upload_total_count
          this.uploadSuccessCount = data.upload_success_count
          this.uploadFailCount = data.upload_fail_count
          this.feedbackFileUrl = data.feedback_file_url
          this.$message.error(this.$t('937'))
        }
      }
    },
    handleOpenUrl() {
      window.open(this.feedbackFileUrl)
    },
    // 上传失败
    // err, file, fileList
    errorHandle(err, file) {
      const index = this.$refs.upload.uploadFiles.findIndex(v => v.name === file.name)
      this.$refs.upload.uploadFiles.splice(index, 1)
      this.$message.error('upload error')
      throw err
    },
    resetDate() {
      this.uploadTotalCount = 0 // 总数
      this.uploadSuccessCount = 0 // 成功数
      this.uploadFailCount = 0 // 失败数
      this.feedbackFileUrl = ''
      this.uploadStatus = false
    },
    // 弹窗关闭时
    closeHandle() {
      this.reset()
      this.resetDate()
    },
    reset() {
      this.$refs.upload.clearFiles()
      this.successFileList = []
    },
    doSubmit() {
      this.visible = false
      this.resetDate()
      this.$emit('submit')
    }
  },
  watch: {
    successFileList: {
      handler(val) {
        if (val.length) this.$emit('uploadSuccess', val)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dialog {
  position: relative;
  .tip {
    font-size: 12px;
    color: red;
    position: absolute;
    left: 174px;
    top: 25px;
  }
}
section {
  margin-bottom: 20px;
}
.upload-dialog-des {
  display: block;
  font-size: 12px;
  line-height: 30px;
  color: #ccc;
}
.upload-demo {
  margin-top: 15px;
  text-align: center;
}
</style>
